import { useEffect } from "react";
import { useAppDispatch } from "../../stores/hooks";
import { setcurrentmenu } from "../../stores/menuslice";
import { Accordion, AccordionDetails, AccordionSummary, Box, Card,CardHeader, Typography } from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import EnvironementSettings from "./childcomponents/environmentsettings";
import NotificationSettings from "./childcomponents/notificationsettings";
import OutputSettings from "./childcomponents/outputsettings";
export default function Settings() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        // document.title = `Hello ${name}`;
        dispatch(setcurrentmenu('settings'));
    }, []);
    return (
        <Box sx={{m:2}}>
            <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography variant="h6"> Environment Settings</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <EnvironementSettings/>
                </AccordionDetails>
            </Accordion>
            {/* <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography variant="h6"> Build/Release Settings</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <OutputSettings/>
                </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography variant="h6"> Notification Settings</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <NotificationSettings/>
                </AccordionDetails>
            </Accordion> */}
        </Box>
    );
}